import React from "react";

const AddIcon = () => (
	<g>
		<path d='M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z' />
	</g>
);

export default AddIcon;
